
import { mapQueryParams } from '@twago/query'
import { EFilter, EWorkPreference } from '@/helpers/enums'

export default {
  name: 'WorkPreference',

  computed: {
    ...mapQueryParams({
      propName: 'workPrefs',
      queryParam: EFilter.WORK_PREFS,
      serializer: (data, ctx) => ctx.serialize(data),
      deserializer: (data, ctx) => ctx.deserialize(data),
      multiple: true
    }),

    items() {
      return [
        {
          id: 'workPrefOnSite',
          value: EWorkPreference.ONSITE,
          text: this.$t('talent.project.search.label.work.preference.onsite')
        },
        {
          id: 'workPrefRemote',
          value: EWorkPreference.REMOTE,
          text: this.$t('talent.project.search.label.work.preference.remote')
        },
        {
          id: 'workPrefHybrid',
          value: EWorkPreference.HYBRID,
          text: this.$t('talent.project.search.label.work.preference.hybrid')
        }
      ]
    }
  },

  methods: {
    serialize(data) {
      return [...new Set(data)].join(',')
    },

    deserialize(data) {
      if (!data?.length) {
        return []
      }

      return [...new Set(data.split(','))]
    }
  }
}
